import {
  LogLevel,
  PublicClientApplication,
  type BrowserCacheLocation,
  type IPublicClientApplication,
} from "@azure/msal-browser";

import { environment } from "../../../environments/environment";

/** MSAL logging — silent in production, info in dev. */
export function loggerCallback(logLevel: LogLevel, message: string): void {
  if (!environment.production) {
    // eslint-disable-next-line no-console
    console.log(message);
  }
}

/**
 * Builds the MSAL PublicClientApplication. redirectUri is derived from the
 * browser origin so localhost stays on localhost and each deployed host uses
 * its own origin (matches Creator's approach).
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  const origin = window.location.origin;
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: `${origin}/`,
      postLogoutRedirectUri: `${origin}/login`,
    },
    cache: {
      cacheLocation: environment.msalConfig.cache
        .cacheLocation as BrowserCacheLocation,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: environment.production ? LogLevel.Error : LogLevel.Info,
        piiLoggingEnabled: !environment.production,
      },
    },
  });
}
